import { toast } from "react-toastify";

export const successNotify = (msg) => toast.success(msg);
export const errorNotify = (msg) => toast.error(msg);
